module.exports = __webpack_public_path__ + "img/apparatus2.ec4d64bf.jpg";